import { IPortfolioAlertResponseProps } from './';

export class PortfolioAlertResponse implements IPortfolioAlertResponseProps {
  errorCode = '';
  formattedMessage = '';
  isSuccess = true;

  public static fromJson = (data: PortfolioAlertResponse): PortfolioAlertResponse => {
    const model = new PortfolioAlertResponse();
    model.errorCode = data.errorCode;
    model.formattedMessage = data.formattedMessage;
    model.isSuccess = data.isSuccess;
    return model;
  };
}
